<div class="row">
    <div class="xl:col-3 lg:col-3 col-12">
        <label>Naam:</label>
    </div>
    <div class="xl:col-9 lg:col-9 col-12">
        <strong>{{ customer?.firstName }} {{ customer?.lastName }}</strong>
    </div>
</div>
<div class="row">
    <div class="xl:col-3 lg:col-3 col-12">
        <label>Klantnummer:</label>
    </div>
    <div class="xl:col-9 lg:col-9 col-12">
        <strong>{{ customer?.customerNumber}}</strong>
    </div>
</div>
<div class="row" *ngIf="customer?.vatNumber">
    <div class="xl:col-3 lg:col-3 col-12">
        <label>BTW Nummer:</label>
    </div>
    <div class="xl:col-9 lg:col-9 col-12">
        <strong>{{ customer?.vatNumber }}</strong>
    </div>
</div>
<div class="row">
    <div class="xl:col-3 lg:col-3 col-12">
        <label>Telefoon:</label>
    </div>
    <div class="xl:col-9 lg:col-9 col-12">
        <strong>{{ customer?.telephone }}</strong>
    </div>
</div>
<div class="row">
    <div class="xl:col-3 lg:col-3 col-12">
        <label>Email:</label>
    </div>
    <div class="xl:col-9 lg:col-9 col-12">
        <strong>{{ customer?.email }}</strong>
    </div>
</div>
